import { API_URL } from "../../api/apiBase";
import {
    CreateQAItem,
    QAModel,
    QAReply,
} from "@/src/components/qa_forum/QAModel";

export async function QASubmit(url: string, accessToken: string, body: any) {
    const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        },
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to submit QA");
    }
    return response.json();
}

export async function createQAItem(
    project_id: string,
    accessToken: string,
    body: CreateQAItem
) {
    return QASubmit(
        `${API_URL}/projects/${project_id}/qa/create`,
        accessToken,
        body
    );
}

export async function updateQAItem(
    project_id: string,
    item_id: string,
    accessToken: string,
    body: QAModel
) {
    return QASubmit(
        `${API_URL}/projects/${project_id}/qa/${item_id}`,
        accessToken,
        body
    );
}

export async function deleteQaItem(
    project_id: string,
    item_id: string,
    accessToken: string
) {
    const response = await fetch(
        `${API_URL}/projects/${project_id}/qa/${item_id}/delete`,
        {
            method: "GET",
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
        }
    );
    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to Delete QA");
    }
    return response.json();
}

export async function getQaItem(
    project_id: string,
    item_id: string,
    accessToken: string
) {
    const response = await fetch(
        `${API_URL}/projects/${project_id}/qa/${item_id}`,
        {
            method: "GET",
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
        }
    );
    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to get QA");
    }
    return response.json();
}

//This will work with limit, but now have CORS

export async function getQaReplies(
    project_id: string,
    item_id: string,
    accessToken: string,
    skip: number,
    limit: number
): Promise<QAReply[]> {
    const response = await fetch(
        `${API_URL}/projects/${project_id}/qa/${item_id}/responses?skip=${skip}&limit=${limit}`,
        {
            method: "GET",
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
        }
    );
    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to get QA replies");
    }
    return response.json();
}
